const dataLayerName = `dataLayerGTM`;
const engines = [`GTM`];

const redactionPatterns = [
  /([\d.a-z]+?)(@|(%40))(.+?)\.(\w)+(\W)*/gi,
  /((tel=)|(telephone=)|(phone=)|(mobile=)|(mob=))[\d\s+][^&/?]+/gi,
  /((firstname=)|(lastname=)|(surname=))[^&/?]+/gi,
  /((password=)|(passwd=)|(pass=))[^&/?]+/gi,
  /((postcode=)|(zipcode=)|(zip=))[^&/?]+/gi,
];
// eslint-disable-next-line unicorn/prefer-set-has
const redactionKeys = [
  'password',
  'pass',
  'passwd',
  'postcode',
  'zipcode',
  'zip',
  'email',
  'firstname',
  'lastname',
  'surname',
  'tel',
  'telephone',
  'phone',
  'mobile',
  'mob',
];

const getTrackingId = () => process.env.VUE_APP_GOOGLE_UA_ID;
const getGtmId = () => process.env.VUE_APP_GOOGLE_GTM_ID;

const isAnalyticsEnabled = () => process.env.VUE_APP_GOOGLE_ENABLED === 'true' && (getTrackingId() || getGtmId());

// eslint-disable-next-line @typescript-eslint/naming-convention
const _methods = {
  GTM: {
    bootstrap: () => {
      if (!getGtmId()) return;

      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      _logger.log('Bootstrapping for GTM');

      window[dataLayerName] = window[dataLayerName] || [];

      // eslint-disable-next-line func-style
      function gtag() {
        // eslint-disable-next-line prefer-rest-params
        window[dataLayerName].push(arguments);
      }

      gtag('js', new Date());
      gtag('config', getGtmId());
      const el = document.createElement('script');

      el.setAttribute('async', 'true');
      el.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${getGtmId()}&l=${dataLayerName}`);

      // awfully test brave of google to always assume there will be a script tag
      const firstScript = document.querySelectorAll('script')[0];

      firstScript.parentNode.insertBefore(el, firstScript);

      const ns = document.createElement('noscript');
      const gtmFrame = document.createElement('iframe');

      gtmFrame.setAttribute('src', `https://www.googletagmanager.com/ns.html?id=${getGtmId()}`);
      gtmFrame.setAttribute('height', '0');
      gtmFrame.setAttribute('width', '0');
      gtmFrame.setAttribute('style', 'display:none;visibility:hidden');
      ns.append(gtmFrame);
      document.body.insertBefore(ns, document.body.firstElementChild);
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    pageView: (to, _from) => {
      if (!getGtmId()) return;

      window[dataLayerName].push({
        event: 'Pageview',
        page_title: to.name,
        page_path: to.fullPath,
      });
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      _logger.log(window[dataLayerName]);
    },
    event: (event, data) => {
      if (!getGtmId()) return;

      window[dataLayerName].push({
        event,
        ...data,
      });
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      _logger.log(window[dataLayerName]);
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const _message = (level, ...args) => {
  const verbose = process.env.VUE_APP_GOOGLE_VERBOSE === 'true';

  if (!verbose) {
    return;
  }

  console[level]('[ANALYTICS]', ...args);
};
// eslint-disable-next-line @typescript-eslint/naming-convention
const _logger = {
  log: (...args) => {
    _message('log', ...args);
  },
  warn: (...args) => {
    _message('warn', ...args);
  },
};

export const bootstrapApp = () => {
  if (!isAnalyticsEnabled()) {
    _logger.warn('Bootstrap called, but analytics are not enabled');

    return;
  }

  engines.forEach((e) => _methods[e].bootstrap());
};

export const pageView = (_to, _from) => {
  if (!isAnalyticsEnabled()) {
    _logger.warn('pageView called, but analytics are not enabled');

    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const [to, from] = [redact(_to), redact(_from)];

  _logger.log('pageView', to, from);
  engines.forEach((e) => _methods[e].pageView(to, from));
};

// eslint-disable-next-line no-shadow
export const publishToGaDataLayer = (event, data) => {
  if (!isAnalyticsEnabled()) {
    _logger.warn('event, but analytics are not enabled');

    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const redacted = redact(data);

  _logger.log('event', redacted);
  engines.forEach((e) => _methods[e].event(event, redacted));
};

const reclaim = (redacted, pattern) => redacted.replace(pattern, '**REDACTED**');
// default to a depth of 5, you can make it a shallow redact with a depth of 1
const redact = (input, depth = 5) => {
  if (!depth || !input) {
    return input;
  }

  if (typeof input === 'string') {
    // eslint-disable-next-line unicorn/no-array-reduce, unicorn/no-fn-reference-in-iterator, unicorn/no-array-callback-reference
    return redactionPatterns.reduce(reclaim, input);
  }

  // TODO: better object checking
  if (Object.prototype.toString.call(input) === '[object Object]') {
    // eslint-disable-next-line unicorn/no-array-reduce, unicorn/no-array-callback-reference, unicorn/prefer-object-from-entries
    return Object.keys(input).reduce((redacted, key) => {
      // eslint-disable-next-line no-param-reassign
      redacted[key] = redactionKeys.includes(key.toLowerCase()) ? '**REDACTED**' : redact(input[key], depth - 1);

      return redacted;
    }, {});
  }

  return input;
};
